export default __webpack_public_path__ + "static/media/borrar.e15203f8.svg";